export const PROTOCOL = process.env.REACT_APP_PROTOCOL;
export const BACKEND_IP = process.env.REACT_APP_BACKEND_IP;
export const BASE_URL = PROTOCOL + "://" + BACKEND_IP + "/";
